import React, { useState, useEffect , useMemo} from 'react';
import { PlusCircle, Pencil } from 'lucide-react'; // Removed Ban and CheckCircle icons
import { useNavigate } from 'react-router-dom';

const CampaignList = () => {
  const [userList, setUsersList] = useState([]);
  const navigate = useNavigate();
  const BUId = sessionStorage.getItem('BUId');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Mailer/GetCampaignList?BUId=${BUId}`);

        if (!userResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await userResponse.json();
        setUsersList(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserData();
  }, [BUId]);

  const handleEditCampaign = (user) => {
    console.log('Campaign data for editing:', user);
    navigate('/AddCampaign', { state: { userData: user } });
  };

  const handleAddCampaign = () => {
    navigate('/AddCampaign');
  };

 // Filter and search functionality
  const filteredMails = useMemo(() => {
    const normalizedSearchTerm = searchTerm.toLowerCase();

    return userList.filter(user => {
     const matchesUser = user.campaignName &&
     user.campaignName.toLowerCase().includes(normalizedSearchTerm);    
     // const matchesSender = user.fromEmail.toLowerCase().includes(normalizedSearchTerm);
    //  const matchesMailType = user.mailType.toLowerCase().includes(normalizedSearchTerm);
      const matchesDate = user.createdOn.toLowerCase().includes(normalizedSearchTerm);
      return matchesUser || matchesDate; //matchesSender || matchesMailType ||
    });
  }, [userList, searchTerm]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMails.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredMails.length / itemsPerPage);


  return (
    <div className="p-8">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">CAMPAIGN DETAILS</h1>
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          onClick={handleAddCampaign}
        >
          <PlusCircle className="h-4 w-4" />
          Create Campaign
        </button>
      </div>
    {/* Search Input */}
        <div className="p-4 bg-gray-100 border-b">
          <div className="max-w-md ml-auto relative">

            <input
              type="text"
              placeholder="Search..."
              className="w-full p-3 pl-10 text-gray-700 bg-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // Reset to first page when searching
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 absolute left-3 top-3 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      {/* Table */}
      <div className="w-full overflow-x-auto bg-white rounded-lg shadow">
        <table className="w-full">
          <thead className="bg-gradient-to-r from-blue-500 to-purple-600">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Campaign Name</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Created On</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-white">Actions</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">Campaign Id</th> {/* Hidden column */}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
                  {currentItems.length > 0 ? (
                currentItems.map((user, index) => (
          //  {userList.length > 0 ? (
            //  userList.map((user, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">{user.campaignName}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{user.createdOn}</td>
                  <td className="px-6 py-4">
                    <div className="flex gap-2">
                      <button
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        onClick={() => handleEditCampaign(user)}
                      >
                        <Pencil className="h-4 w-4 text-gray-600" />
                      </button>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.campaignId}</td> {/* Hidden column data */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="px-6 py-4 text-sm text-center text-gray-600">No Campaigns found</td>
              </tr>
            )}
          </tbody>
        </table>
         {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                  ${currentPage === index + 1
                    ? 'bg-blue-500 text-white border-blue-500'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignList;
